import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../css/Tabs.css';

interface TabsProps {
  activeTab: 'fee' | 'coupon' | 'refund';
}

const Tabs: React.FC<TabsProps> = ({ activeTab }) => {
  const navigate = useNavigate();

  return (
    <div className="payment-tabs">
      <div
        className={`payment-tab ${activeTab === 'fee' ? 'active' : ''}`}
        onClick={() => navigate('/fee-tax')}
      >
        Fee & Tax Config
      </div>
      <div
        className={`payment-tab ${activeTab === 'coupon' ? 'active' : ''}`}
        onClick={() => navigate('/coupons')}
      >
        Promo Code
      </div>
      <div
        className={`payment-tab ${activeTab === 'refund' ? 'active' : ''}`}
        onClick={() => navigate('/refund')}
      >
        Refund
      </div>
    </div>
  );
};

export default Tabs;
